
import React, { useContext, useState } from 'react';
import { Space, Table, Tag, Popconfirm, Image, Input, Row, Col } from 'antd';
import { AudioOutlined, DeleteFilled, DeleteOutlined, EditOutlined, EyeOutlined, MessageOutlined, PlusCircleFilled, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Cascader } from 'antd';
import { Button, } from 'antd';
import { ApiConfig } from '../../services/ApiConfigs';
import { ApiServices } from '../../services/apiServices';
import Search from 'antd/es/input/Search';
import MessageCmp from './MessageCmp';
import { DriverContext } from '.';
import ViewDrivers from './ViewDrivers';

const UserDataTable = () => {

    const { loading, deleteUser, userData, setViewModalOpen, setSelectedDriver, setAddModalOpen, isFranchise } = useContext(DriverContext)

    const [selectedValue, setSelectedValue] = useState(['0']);
    const [selectedUser, setSelectedUser] = useState([]);
    const [value, setValue] = useState('');


    const options = [
        { value: '0', label: 'Active' },
        { value: '1', label: 'Blocked' }
    ]

    const onChange = async (status, value) => {
        setSelectedValue(status[0])
    };

    const [sendMessageModal, setSendMessageModal] = useState(false);
    const [messageType, setMessageType] = useState("");

    const columns = [
        {
            title: 'Image',
            dataIndex: 'photoData',
            key: 'photoData',
            width: 76,
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
            render: (image) => (
                <Image
                    src={image?.url ? image?.url : "/image/user.png"}
                    width={48}
                    height={48}
                    style={{ borderRadius: 50, objectFit: 'cover' }}
                />
            ),
        },
        {
            title: 'Name',
            dataIndex: 'firstName',
            key: 'firstName',
            minWidth: 150,
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
            sorter: (a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName),
            render: (text, record) => (
                <div style={{ whiteSpace: 'nowrap' }}>
                    <div style={{ fontWeight: 600, color: '#0f172a' }}>{text + ' ' + record.lastName}</div>
                    <div style={{ fontSize: 12, color: '#64748b' }}>{record.phone}</div>
                </div>
            ),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            minWidth: 180,
            responsive: ['md', 'lg', 'xl'],
            render: (text) => <span style={{ color: '#475569' }}>{text}</span>,
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            responsive: ['lg', 'xl'],
            render: (text) => <span style={{ color: '#64748b', fontSize: 12 }}>{text}</span>,
        },
        {
            title: 'Status',
            dataIndex: 'isAvailable',
            key: 'isAvailable',
            width: 100,
            responsive: ['sm', 'md', 'lg', 'xl'],
            filters: [
                { text: 'Online', value: 'Online' },
                { text: 'Offline', value: 'Offline' }
            ],
            onFilter: (value, record) => record.isAvailable === value,
            render: (text) => (
                <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 5,
                    fontWeight: 600,
                    fontSize: 12,
                    color: text === 'Offline' ? '#64748b' : '#16a34a',
                }}>
                    <span style={{
                        width: 7, height: 7, borderRadius: '50%',
                        background: text === 'Offline' ? '#94a3b8' : '#22c55e',
                        display: 'inline-block',
                    }} />
                    {text}
                </span>
            ),
        },
        {
            title: 'Vehicle',
            dataIndex: 'vehicleType',
            key: 'vehicleType',
            responsive: ['md', 'lg', 'xl'],
            render: (text) => <span style={{ color: '#475569' }}>{text || '—'}</span>,
        },
        ...(!isFranchise ? [{
            title: 'Franchise',
            dataIndex: 'franchise',
            key: 'franchise',
            minWidth: 140,
            responsive: ['md', 'lg', 'xl'],
            render: (franchise) => franchise ? (
                <Tag color="purple" style={{ borderRadius: 6, fontWeight: 500, padding: '2px 8px' }}>
                    {franchise.name || franchise.city || `Franchise #${franchise.id}`}
                </Tag>
            ) : (
                <Tag color="default" style={{ borderRadius: 6, color: '#64748b' }}>Direct Store</Tag>
            ),
        }] : []),
        {
            title: 'Action',
            key: 'action',
            width: 120,
            fixed: 'right',
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
            render: (_, record) => (
                <Space size="middle">
                    <Space size="middle">
                        <div onClick={() => {
                            console.log(record, "view", _)
                            setSelectedDriver(record)
                            setViewModalOpen(true)
                        }}>
                            <EyeOutlined />
                        </div>

                        <div onClick={() => {
                            setSelectedDriver(record)
                            setAddModalOpen(true)
                        }}>
                            <EditOutlined />
                        </div>

                        <Popconfirm
                            title="Delete the task"
                            description="Are you sure to delete this task?"
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: 'red',
                                    }}
                                />
                            }
                            onConfirm={() => deleteUser(record.id)}
                        >
                            <DeleteOutlined />
                        </Popconfirm>

                        <div onClick={() => {
                            setMessageType(1)
                            setSendMessageModal(true)
                            setSelectedUser(record)
                        }}>
                            <MessageOutlined />
                        </div>
                    </Space >
                </Space >
            ),
        },
    ];

    const [searchData, setSearchData] = useState([]);


    return (
        <div style={{ marginTop: 8 }}>
            <MessageCmp isModalOpen={sendMessageModal} setIsModalOpen={setSendMessageModal} type={messageType} selectedUser={selectedUser} />
            
            <div style={{
                background: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: 12,
                padding: '16px 18px',
                marginBottom: 16,
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 12
            }}>
                <Button 
                    onClick={() => {
                        setMessageType(0)
                        setSendMessageModal(true)
                    }} 
                    type="primary" 
                    icon={<MessageOutlined style={{ fontSize: 16 }} />}
                    style={{
                        height: 38,
                        borderRadius: 8,
                        fontWeight: 600,
                        background: '#2563eb'
                    }}
                >
                    Broadcast Announcement
                </Button>

                <div style={{ flex: '1 1 240px', maxWidth: 360 }}>
                    <Search
                        placeholder="Search by driver name..."
                        allowClear
                        enterButton
                        size="middle"
                        style={{ width: '100%' }}
                        onChange={e => {
                            const currValue = e.target.value.toLowerCase();
                            setValue(currValue);
                            const filteredData = Array.isArray(userData) ? userData.filter(entry =>
                                (entry.firstName && entry.firstName.toLowerCase().includes(currValue)) || 
                                (entry.lastName && entry.lastName.toLowerCase().includes(currValue)) ||
                                (entry.phone && entry.phone.toLowerCase().includes(currValue))
                            ) : [];
                            if (currValue) {
                                setSearchData(filteredData);
                            } else {
                                setSearchData([]);
                            }
                        }}
                    />
                </div>
            </div>

            <Table
                columns={columns}
                dataSource={value ? searchData : userData}
                loading={loading}
                pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '30'],
                    style: { padding: '12px 16px', margin: 0 }
                }}
                scroll={{ x: 600 }}
                rowKey="id"
            />
            <ViewDrivers />
        </div>
    );
};

export default UserDataTable;